import type { Price } from "../../../../actions/feed/feed.ts";

export function formatPrice(feedPrice: Price): string {
  const localizedPrice =
    feedPrice.amount > 0 ? `${feedPrice.amount.toLocaleString("de-DE")} €` : "";

  if (feedPrice.type === "GIVE_AWAY") {
    return "Zu verschenken";
  }
  if (feedPrice.type === "NEGOTIABLE") {
    return `${localizedPrice} VB`;
  }
  return localizedPrice;
}
